<template>
    <layout-auth>
        <card-auth>
            <b-row class="">
                <b-col cols="12">
                    <h5 class="text-left mb-3"> {{ $t(`로그인`) }} </h5>
                    <b-form
                        class=""
                        :disabled-field="status"
                        @submit.prevent="login"
                        >
                        <b-form-row class="mb-3">
                            <b-col cols="12">
                                <b-form-group id="signin-group-email" :label="$t(`이메일 (로그인 ID)`)" label-for="signin-email" label-sr-only>
                                    <b-form-input
                                        id="signin-email"
                                        v-model="user.e_mail"
                                        type="email"
                                        :placeholder="$t(`이메일 (로그인 ID)`)"
                                        class="login-card-input"
                                        size="lg"
                                        required
                                        />
                                </b-form-group>
                            </b-col>
                            <b-col cols="12">
                                <b-form-group id="signin-group-password" :label="$t(`비밀번호`)" label-for="signin-password" label-sr-only :class="[{ 'mb-0': !status && isSuccess.state === false }]">
                                    <b-form-input
                                        id="signin-password"
                                        v-model="user.password"
                                        type="password"
                                        :placeholder="$t(`비밀번호`)"
                                        class="login-card-input"
                                        size="lg"
                                        required
                                        />
                                </b-form-group>
                            </b-col>
                            <template v-if="!status && isSuccess.state === false">
                                <b-col cols="12" class="">
                                    <b-form-text
                                        class="text-center text-danger fw-500 f-95 mb-4"
                                        text-variant="danger"
                                        >
                                        <template v-if="isSuccess.isAssessmentError">
                                            <fa icon="exclamation-circle"></fa> <span v-html="this.$t(isSuccess.message)"></span>
                                        </template>
                                        <template v-else>
                                            <fa icon="exclamation-circle"></fa> {{ this.$t(isSuccess.message) }}
                                        </template>
                                        <!-- 신청을 마치지 않은 계정: 어디서 신청하는지와 문의 창(layout-auth 의 customer-service)을 함께 안내 -->
                                        <div v-if="isSuccess.code === 'Not_Found_Request'" class="gray-700 fw-400 mt-2">
                                            {{ $t('초대 메일의 평가 신청 링크로 신청을 마쳐 주세요.') }}
                                            <b-link v-b-modal.customer-service class="ml-1">{{ $t('서비스 문의') }}</b-link>
                                        </div>
                                    </b-form-text>
                                </b-col>
                            </template>
                            <b-col cols="12">
                                <b-btn
                                    type="submit"
                                    class="login-card-submit"
                                    variant="dark"
                                    size="lg"
                                    :disabled="status"
                                    block
                                    rounded
                                    pill
                                    >
                                    <template v-if="status">
                                        <div class="d-flex align-items-center justify-content-center my-2">
                                            <b-spinner class="login-spinner" small></b-spinner>
                                        </div>
                                    </template>
                                    <template v-else>{{ $t(`로그인`) }}</template>
                                </b-btn>
                            </b-col>
                        </b-form-row>
                        <b-form-row class="">
                            <b-col cols="6" class="">
                                <b-form-checkbox
                                    id="checkbox-compnay-type"
                                    v-model="user.company_type"
                                    name="checkbox-compnay-type"
                                    value="request"
                                    unchecked-value="participate"
                                    :disabled="status"
                                    @change="syncTypeQuery"
                                    >
                                    {{ $t('의뢰기업 로그인') }}
                                </b-form-checkbox>
                                <b-form-text class="mt-1">{{ $t('원청사(의뢰기업) 담당자만 체크하세요.') }}</b-form-text>
                                
                            </b-col>
                            <b-col cols="6" class="text-right">
                                <b-link :to="{ name: 'findPassword' }" class="dark-a-under"> {{ $t(`비밀번호 찾기`) }} </b-link>
                            </b-col>
                        </b-form-row>
                    </b-form>
                </b-col>
            </b-row>
        </card-auth>
    </layout-auth>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';
import * as Sentry from '@sentry/browser';
import { mapState, mapActions, mapMutations } from 'vuex';
import layoutAuth from '@/components/common/layout-auth.vue';
import cardAuth from '@shared_components/common/card-auth.vue';

export default {
    name: 'DashboardLogin',
    components: {
        layoutAuth,
        cardAuth
    },
    data () {
        return {
            // ?type=request 로 들어오면 의뢰기업 로그인으로 시작한다(원청사 안내용 주소)
            user : { e_mail: '', password: '', company_type: this.$route.query.type === 'request' ? 'request' : 'participate' },
            status: false,
            isSuccess: { state: null, message: null }
        };
    },
    computed: {
        ...mapState(['user_id', 'company_id']),
    },
    watch: {
        // 입력을 고치면 이전 실패 안내를 지운다
        user: {
            deep: true,
            handler () {
                if (this.isSuccess.state === false) {
                    this.isSuccess = { state: null, message: null };
                }
            }
        }
    },
    mounted() {
        // 세션 만료(401)로 온 경우 사유를 화면 안에 안내한다 — commonLogout 이 reason=session 을 붙인다(새로고침해도 유지)
        if (this.$route.query.reason === 'session') {
            this.isSuccess = { state: false, message: '다중 로그인 등 권한 오류가 발생했습니다. 다시 로그인해 주십시오.' };
        }
    },
    methods: {
        ...mapActions('payment', ['checkIsPurchased']),
        ...mapMutations(['auth_success']),
        ...mapMutations('contractor', ['SET_CONTRACTOR_ACCOUNT']),
        syncTypeQuery (company_type) {
            const { type: _type, ...query } = this.$route.query;
            if (company_type === 'request') query.type = 'request';
            this.$router.replace({ query }).catch(() => {});
        },
        safeRedirectRoute () {
            // 로그인 후 redirect 쿼리로 돌아갈 안전한 내부 경로만 허용(open-redirect 방지).
            // MCP OAuth 흐름에서 guard 가 /mcp/authorize?request_id=... 를 redirect 로 넘긴다.
            const redirect = this.$route.query.redirect;
            if (
                typeof redirect === 'string' &&
                redirect.startsWith('/') &&
                !redirect.startsWith('//') &&
                !redirect.startsWith('/\\')
            ) {
                return redirect;
            }
            return null;
        },
        async login () {
            try {
                this.status = true;
                // withCredentials: 로그인 응답의 refresh 쿠키(httpOnly, SameSite=None, cross-site)를
                // 브라우저가 저장하려면 요청이 credentialed 여야 한다. 없으면 쿠키가 저장되지 않아
                // JWT 만료 시 refresh 가 REFRESH_TOKEN_MISSING 으로 실패한다(파일럿 staging 검증에서 확인).
                const _sign_in_res = await this.$axios.post(`/clients/login?type=${this.user.company_type}`, this.user, { withCredentials: true });
                const _signed_in = _sign_in_res.data;

                // Sentry에 User Identity 전송
                Sentry.setUser({
                    id: _signed_in.user_id,
                    name: _signed_in.user_name,
                    email: _signed_in.e_mail,
                    type: this.user.company_type,
                    company_id: _signed_in.company_id,
                    company_name: _signed_in.company_name
                });

                // Sentry User Login Breadcrumb 추가
                Sentry.addBreadcrumb({
                    level: 'Info',
                    type: 'Auth',
                    category: 'Login',
                    data: {
                        id: _signed_in.user_id,
                        email: _signed_in.e_mail,
                        company_id: _signed_in.company_id,
                        company_name: _signed_in.company_name
                    }
                });

                // 기아담당자 테스트 코드 삭제 예정코드 — 두 계정이 잘못된 유형으로 들어오면 막고 화면 안에 안내한다
                if (['admin.damin.park@kia.com', 'damin.park@kia.com'].includes(_signed_in.e_mail)) {
                    let wrong_type_message = null;
                    if (_signed_in.client === true && this.user.company_type !== 'request') {
                        wrong_type_message = '잘못된 접근입니다. "의뢰기업 로그인"을 체크 후 로그인하여 주십시오.';
                    } else if (_signed_in.client !== true && this.user.company_type === 'request') {
                        wrong_type_message = '잘못된 접근입니다. "의뢰기업 로그인"을 해제 후 로그인하여 주십시오.';
                    }
                    if (wrong_type_message) {
                        await this.$store.dispatch('logout');
                        this.isSuccess = { state: false, message: wrong_type_message };
                        return false;
                    }
                }

                // JWT 점진 채택: 백엔드가 accessToken(레거시 api_key)과 함께 jwtAccessToken(15분 RS256)을
                // 추가 발급하면, 저장/전송에 쓰이는 accessToken 값을 JWT 로 교체한다(participate·request 공통,
                // 구분 없음). 발급 실패 시 기존 api_key 유지(하위호환). access 만료(401)는 axios 응답
                // 인터셉터가 refresh 쿠키로 재발급 처리한다.
                if (_signed_in.jwtAccessToken) {
                    _signed_in.accessToken = _signed_in.jwtAccessToken;
                }

                if (this.user.company_type === 'request') {
                    for (const _info_key in _signed_in) {
                        localStorage.setItem(_info_key.toLocaleLowerCase(), _signed_in[_info_key]);
                    }
                    // 토큰 키 통일: 의뢰기업 흐름도 참여자와 동일하게 카멜 'accessToken' 에 저장한다.
                    // (위 for..in 은 소문자 'accesstoken' 도 만들지만 더는 읽지 않는다 — 잔여, CONTRACT 에서 제거.)
                    if (_signed_in.accessToken) {
                        localStorage.setItem('accessToken', _signed_in.accessToken);
                    }
                    localStorage.setItem('type', this.user.company_type);
                    this.SET_CONTRACTOR_ACCOUNT(_signed_in);

                    if (_signed_in.is_admin === 4) {
                        this.auth_success(_signed_in);
                    }
                    
                    this.$router.replace(this.safeRedirectRoute() || {
                        name: 'ContractorProgress',
                        params: {
                            'requestsId': localStorage.getItem('company_id'),
                        }
                    });
                } else {
                    localStorage.setItem('type', this.user.company_type);
                    this.auth_success(_signed_in);
                    this.$router.replace(this.safeRedirectRoute() || { name: 'Main' });
                }
                this.isSuccess.state = true;
            } catch (error) {
                let [error_message, isAssessmentError, code] = [null, false, null];
                if (error.response) {
                    const _statusCode = error.response.status;
                    isAssessmentError = error.response.data?.assessment;
                    if (_statusCode === 404) {
                        code = getErrorMessage(error, '');
                        if (code === 'Not_Found_User') {
                            error_message = '이메일 또는 비밀번호가 일치하지 않습니다.';
                        } else if (code === 'Not_Found_Request') {
                            error_message = '평가신청이 완료되지 않은 계정입니다. 평가신청을 완료해주시거나 QESG에 문의해주세요.';
                        }
                    } else if (_statusCode === 403) {
                        error_message =this.$t('캠페인 접근권한이 아직 없습니다. 평가신청 완료 이메일을 참고해주세요.');
                    } else if (_statusCode === 400) {
                        if (error.response.data.msg === '잘못된 접근입니다. 참여기업으로 로그인하여 주십시오.') {
                            if (error.response.data.assessment) {
                                let period_arr = error.response.data.period.split('_');
                                if (period_arr[0]) {
                                    error_message = `${period_arr[0]} ${this.$t('년')} `;
                                }
                                
                                if (period_arr[1]) {
                                    period_arr[1] = period_arr[1].replace(/H/i, this.$t('분기'));
                                    error_message += `${period_arr[1]} `;
                                }

                                if (error.response.data.project_code) {
                                    error_message += `${error.response.data.project_code} ${this.$t('프로젝트에 참여한 이력이 있습니다.')} <br>`;
                                } else {
                                    error_message += this.$t('프로젝트에 참여한 이력이 있습니다.');
                                }

                                error_message += this.$t('평가 참여 페이지로 이동을 원하실 경우, 의뢰기업 로그인 체크박스를 해지하신 후 로그인 해주시고, 평가 의뢰를 원하실 경우, 아래 서비스 문의를 클릭해 문의를 남겨주세요.');
                            } else {
                                error_message = this.$t('평가 참여 이력이 없습니다. 평가 의뢰를 원하실 경우, 아래 서비스 문의를 클릭해 문의를 남겨주세요.');
                            }
                        } else if (getErrorMessage(error, '') === '패스워드가 일치하지 않아 로그인에 실패하였습니다') {
                            error_message = this.$t('이메일 또는 비밀번호가 일치하지 않습니다.');
                        }
                    } else {
                        error_message = this.$t('알 수 없는 에러가 발생했습니다. 잠시 후 다시 시도해주세요.');
                    }
                } else {
                    error_message = this.$t('알 수 없는 에러가 발생했습니다. 잠시 후 다시 시도해주세요.');
                }
                
                // 매핑되지 않은 응답(예: 'type을 입력하지 않았습니다.')도 이유 없는 빈 줄이 되지 않게 한다
                this.isSuccess = {
                    state: false,
                    message: error_message || '알 수 없는 에러가 발생했습니다. 잠시 후 다시 시도해주세요.',
                    isAssessmentError,
                    code
                };
            } finally {
                this.status = false;
            }
        }
    }
};

</script>
<style lang="scss" scoped>
@import '@styles/page/_dashboard_login.scss';

.auth-helpers {
    &__divider {
        color: #495057;
    }
    a,
    a:hover {
        color: #495057;
        text-decoration: none;
    }

    // @media screen and (min-width: 992.00px) {
    //     border-bottom: 1px solid #f8f9fa;
    // }
}
</style>
<style>
#customer-service___BV_modal_content_ >.modal-body {
    border-bottom-left-radius: calc(0.3rem - 1px);
    border-bottom-right-radius: calc(0.3rem - 1px);
}
</style>
